"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var reactn_1 = tslib_1.__importStar(require("reactn"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var styles = require('./index.scss');
exports.Question = function (props) {
    var qaList = reactn_1.useGlobal()[0];
    var question = qaList[props.show];
    var wrapperClassNames = classnames_1.default(styles.question, styles.active);
    return (reactn_1.default.createElement("div", { className: wrapperClassNames },
        console.log(question),
        reactn_1.default.createElement("h4", null,
            props.show,
            "\u756A\u76EE\u306E\u8CEA\u554F"),
        reactn_1.default.createElement("p", null, question)));
};
